module.exports = __webpack_public_path__ + "static/media/volume_red.dc418937.svg";